import ProductsArchivePage from './ProductsArchivePage';

export default ProductsArchivePage;
